export default __webpack_public_path__ + "static/media/border-bg.8dcb465f.png";